import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:4000/api',
  withCredentials: true,
});

const TOKEN_KEY = 'notebool_auth_token';

export const getAuthToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch (error) {
    return null;
  }
};

export const setAuthToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
      API.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
      localStorage.removeItem(TOKEN_KEY);
      delete API.defaults.headers.common.Authorization;
    }
  } catch (error) {
    // Ignore storage access errors in restricted environments.
  }
};

const existingToken = getAuthToken();
if (existingToken) {
  setAuthToken(existingToken);
}

export const register = (data) => API.post('/auth/register', data);
export const login = (data) => API.post('/auth/login', data);
export const getMe = () => API.get('/auth/me');
export const logout = () => API.post('/auth/logout');

export const uploadDocument = (formData, config = {}) => API.post('/documents/upload', formData, {
  timeout: 120000,
  ...config,
  headers: {
    'Content-Type': 'multipart/form-data',
    ...(config.headers || {}),
  },
});
export const uploadDocumentBatch = (formData, config = {}) => API.post('/documents/upload-batch', formData, {
  timeout: 300000,
  ...config,
  headers: {
    'Content-Type': 'multipart/form-data',
    ...(config.headers || {}),
  },
});
export const getDocuments = (params) => API.get('/documents', { params });
export const getDocument = (id) => API.get(`/documents/${id}`);
export const deleteDocument = (id) => API.delete(`/documents/${id}`);
export const analyzeDocument = (id) => API.post(`/documents/${id}/analyze`);
export const chatWithDocument = (id, data) => API.post(`/documents/${id}/chat`, data);
export const analyzeMultipleDocuments = (data) => API.post('/documents/multi-analyze', data);
export const chatWithMultipleDocuments = (data) => API.post('/documents/multi-chat', data);
export const suggestDocumentQuestions = (id) => API.post(`/documents/${id}/suggest-questions`);
export const suggestPortfolioQuestions = (data) => API.post('/documents/multi-suggest-questions', data);
